import { useMutation } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { createPhoneCallCapture } from "./api"

interface CreatePhoneCallCaptureVariables {
  phoneNumber: string
  householdId?: string
  meetingId?: string
  title?: string
}

export function useCreatePhoneCallCapture() {
  const getContext = useApiContext()

  return useMutation({
    mutationFn: async ({ phoneNumber, householdId, meetingId, title }: CreatePhoneCallCaptureVariables) => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return createPhoneCallCapture(context, { phoneNumber, householdId, meetingId, title })
    },
    meta: {
      errorToast: { fallback: "Failed to initiate phone call" },
    },
  })
}
